import * as React from "react"
import { getCountryCallingCode } from "libphonenumber-js"
import { countries } from "countries-list"
import { TypeItemRenderer } from "../DropdownSelect"

export const countrySelected: TypeItemRenderer = item => {
    return <div>
        <img
            width="32px"
            src={`images/countriesFlags/${item.value.toLowerCase()}.svg`}
            alt=""
            style={{
                position: "relative",
                boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                verticalAlign: "middle",
                bottom: 10
            }}
        />
        <span style={{
            display: "inline-block",
            fontSize: "1em",
            lineHeight: "1.5em",
            verticalAlign: "middle",
            marginLeft: 10
        }}>+{getCountryCallingCode(item.value)}</span>
    </div>
}

export const countryOption: TypeItemRenderer = item => {
    const { value } = item
    const country = countries[value as keyof typeof countries]
    return <div style={{
        display: "flex",
        height: "100%",
        width: "100%",
        alignItems: "center"
    }}>
        <img
            width="26px"
            style={{ marginRight: 10 }}
            src={`images/countriesFlags/${item.value.toLowerCase()}.svg`}
            alt="" />
        <span style={{ marginRight: 10, fontSize: 16 }}>
            <span>{country.name}</span>
            {country.name !== country.native && <span style={{ marginRight: 10 }}> ({country.native})</span>}
            <span style={{ opacity: 0.5 }}> {"+" + getCountryCallingCode(value)}</span>
        </span>
    </div>
}